/**
 * Customer portal BaB editor only (#bundleapp-subscriptions-portal).
 * - Restore wheel / trackpad scrolling (scrollbar already works).
 * - Inject a Back button in .awt-bundle-update-content-footer.
 */
(function () {
  var PORTAL_ID = 'bundleapp-subscriptions-portal';
  var FOOTER_SELECTOR = '.awt-bundle-update-content-footer';
  var BACK_ATTR = 'data-custom-bab-portal-back';
  var NESTED_SCROLL_SELECTOR =
    '.custom-bab-selection-popup, [data-custom-bab-selection-popup], .awt-filters-menu-list, .chakra-menu__menu-list, .slide-panel-container, .chakra-modal__content';

  var scheduled = false;
  var cachedScroller = null;
  var boundWheel = false;

  function getPortal() {
    return document.getElementById(PORTAL_ID);
  }

  function getUpdateFooter() {
    var portal = getPortal();
    return portal ? portal.querySelector(FOOTER_SELECTOR) : null;
  }

  function isPortalPage() {
    var path = window.location.pathname || '';
    return (
      document.body.classList.contains('awtomic-customer-portal-open') ||
      path.indexOf('/tools/bundle-subscriptions') === 0 ||
      path.indexOf('/apps/bundle-subscriptions') === 0
    );
  }

  function canScroll(el) {
    return !!(el && el.scrollHeight - el.clientHeight > 1);
  }

  function isScrollableBox(el) {
    if (!el || el.nodeType !== 1) return false;
    var style = window.getComputedStyle(el);
    var oy = style.overflowY;
    return (oy === 'auto' || oy === 'scroll' || oy === 'overlay') && canScroll(el);
  }

  function findOverflowScroller(root) {
    if (!root) return null;
    var best = isScrollableBox(root) ? root : null;
    var bestOverflow = best ? root.scrollHeight - root.clientHeight : 0;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!isScrollableBox(el)) continue;
      var extra = el.scrollHeight - el.clientHeight;
      if (extra > bestOverflow) {
        bestOverflow = extra;
        best = el;
      }
    }
    return best;
  }

  function getScroller() {
    if (cachedScroller && document.contains(cachedScroller) && canScroll(cachedScroller)) {
      return cachedScroller;
    }

    var portal = getPortal();
    var footer = getUpdateFooter();
    var scroller = null;

    if (footer) {
      scroller =
        footer.closest('.bundleapp-modal__container--complete-screen') ||
        (portal && portal.querySelector('.bundleapp-modal__container--complete-screen'));
      if (!canScroll(scroller) && portal) {
        scroller = findOverflowScroller(portal);
      }
    } else if (portal) {
      scroller = findOverflowScroller(portal);
    }

    if (!canScroll(scroller)) {
      if (canScroll(document.documentElement)) scroller = document.documentElement;
      else if (canScroll(document.body)) scroller = document.body;
    }

    cachedScroller = scroller || null;
    return cachedScroller;
  }

  function wheelDelta(e, scroller) {
    var delta = e.deltaY;
    if (e.deltaMode === 1) delta *= 16;
    if (e.deltaMode === 2) delta *= scroller.clientHeight || 1;
    return delta;
  }

  function onWheel(e) {
    if (!isPortalPage()) return;
    if (e.ctrlKey) return;

    var portal = getPortal();
    if (!portal) return;

    var target = e.target;
    if (target && target.nodeType === 3) target = target.parentElement;
    if (target && !portal.contains(target) && target !== portal) return;

    var nested = target && target.closest && target.closest(NESTED_SCROLL_SELECTOR);
    if (nested && nested !== portal && isScrollableBox(nested)) return;

    var scroller = getScroller();
    if (!scroller) return;

    var max = scroller.scrollHeight - scroller.clientHeight;
    if (max <= 1) return;

    var start = scroller.scrollTop;
    var delta = wheelDelta(e, scroller);

    requestAnimationFrame(function () {
      if (Math.abs(scroller.scrollTop - start) >= 1) return;
      var next = Math.min(max, Math.max(0, start + delta));
      if (next !== scroller.scrollTop) scroller.scrollTop = next;
    });
  }

  function bindWheel() {
    if (boundWheel) return;
    boundWheel = true;
    document.addEventListener('wheel', onWheel, { capture: true, passive: true });
  }

  function clickNativeClose(portal) {
    var header = portal.querySelector(
      '.bundleapp-modal__container--complete-screen--header-container'
    );
    if (!header) return false;

    var btn = header.querySelector('button');
    if (!btn) {
      var icon = header.querySelector('.bundle-close-icon');
      btn = icon && icon.closest('button');
    }
    if (!btn || btn.hasAttribute(BACK_ATTR)) return false;

    btn.click();
    return true;
  }

  function leaveEditor() {
    var portal = getPortal();
    if (portal && clickNativeClose(portal)) return;

    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    window.location.href = '/tools/bundle-subscriptions';
  }

  function insertBackButton(footer, button) {
    var bar = footer.querySelector('.awt-bundle-update-footer-bar') || footer;
    var info = bar.querySelector('.awt-bundle-update-footer-button-info');
    var children = bar.children;
    var slot = null;

    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child.hasAttribute && child.hasAttribute('data-custom-bab-spend-bar')) continue;
      if (child.classList.contains('awt-bundle-update-footer-button-info')) continue;
      if (child.hasAttribute(BACK_ATTR)) continue;
      slot = child;
      break;
    }

    if (slot) {
      slot.insertBefore(button, slot.firstChild);
      return;
    }
    if (info) {
      info.insertBefore(button, info.firstChild);
      return;
    }
    bar.insertBefore(button, bar.firstChild);
  }

  function ensureBackButton(footer) {
    var existing = footer.querySelector('[' + BACK_ATTR + ']');
    if (existing) return existing;

    var native = footer.querySelector('button.button--secondary');
    if (native) {
      native.setAttribute(BACK_ATTR, '');
      native.classList.add('custom-bab-portal-back');
      return native;
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bundle-button button--secondary custom-bab-portal-back';
    button.setAttribute(BACK_ATTR, '');
    button.setAttribute('aria-label', 'Go back');
    button.textContent = 'Back';
    insertBackButton(footer, button);
    return button;
  }

  function syncFooter() {
    var footer = getUpdateFooter();
    if (!footer) return;
    ensureBackButton(footer);
    cachedScroller = null;
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      syncFooter();
    });
  }

  function init() {
    if (!isPortalPage() && !getPortal()) {
      var wait = new MutationObserver(function () {
        if (getPortal() || isPortalPage()) {
          wait.disconnect();
          init();
        }
      });
      wait.observe(document.documentElement, { childList: true, subtree: true });
      return;
    }

    bindWheel();
    syncFooter();

    document.addEventListener(
      'click',
      function (e) {
        var back = e.target && e.target.closest && e.target.closest('[' + BACK_ATTR + ']');
        if (!back || !getUpdateFooter()) return;
        e.preventDefault();
        e.stopPropagation();
        leaveEditor();
      },
      true
    );

    var portal = getPortal() || document.body;
    var observer = new MutationObserver(function () {
      cachedScroller = null;
      scheduleSync();
    });
    observer.observe(portal, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
